<div class="progress-bar">
    <div class="step first selected"></div>
    <div class="step second" [ngClass]="hightlightedSteps.second ? 'selected' : ''"></div>
    <div class="step third" [ngClass]="hightlightedSteps.third ? 'selected' : ''"></div>
    <div class="step fourth" [ngClass]="hightlightedSteps.fourth ? 'selected' : ''"></div>
</div>
